import React, { useContext } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { ThemeContext } from "providers/ThemeProvider";
import { Header } from "components/theme";
import { Container, Button } from "components/common";
import heroImage from "assets/illustrations/header.jpg";
import {
  greeting,
  greetingDescription,
  linkedinUrl,
  githubUrl,
  cvLink,
  gmailUrl,
  discordUrl,
  twitterUrl,
} from "data/config";
//gmail
import gmailLogoWhite from "assets/illustrations/gmail.png";
import gmailLogoDark from "assets/illustrations/gmail.png";

//linkedin
import linkedinLogo from "assets/illustrations/linkedin.png";
import linkedinLogoWhite from "assets/illustrations/linkedin.png";

//github
import githubLogo from "assets/illustrations/github.png";
import githubLogoWhite from "assets/illustrations/github.png";

import discordLogo from "assets/illustrations/discord.png";
import twitterLogo from "assets/illustrations/twitter.png";

import { IntroWrapper, Details, Thumbnail } from "./styles";

export const Intro = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div>
      <Header />
      <IntroWrapper as={Container}>
        <Details theme={theme}>
          <h1>{greeting}</h1>
          <p>{greetingDescription}</p>
          <ul>
            <li> Open Source Enthusiast 🙌 </li>
            <li> Love to build projects 👨‍</li>
          </ul>

          <img
            width='100%'
            src='https://activity-graph.herokuapp.com/graph?username=majjikishore007&theme=react-dark'
          />

          <div>
            <Button as={AnchorLink} href='#contact' className='hire-me'>
              Hire me
            </Button>{" "}
            <a href={cvLink} target='_blank' rel='noreferrer'>
              <Button className='view-cv'>View CV</Button>
            </a>
          </div>
          <div className='social'>
            {" "}
            <a href={linkedinUrl} target='_blank' rel='noreferrer'>
              <img
                width='45'
                src={theme === "light" ? linkedinLogo : linkedinLogoWhite}
                alt='Linkedin'
              />
            </a>
            <a href={githubUrl} target='_blank' rel='noreferrer'>
              <img
                width='45'
                src={theme === "light" ? githubLogo : githubLogoWhite}
                alt='GitHub'
              />
            </a>
            <a href={gmailUrl} target='_blank' rel='noreferrer'>
              <img
                width='45'
                src={theme === "light" ? gmailLogoWhite : gmailLogoDark}
                alt='Gmail'
              />
            </a>
            <a href={twitterUrl} target='_blank' rel='noreferrer'>
              <img width='45' src={twitterLogo} alt='Twitter' />
            </a>
            <a href={discordUrl} target='_blank' rel='noreferrer'>
              <img width='45' src={discordLogo} alt='Discord' />
            </a>
            <a href='https://www.buymeacoffee.com/majjikishore' target='_blank'>
              <img
                src='https://cdn.buymeacoffee.com/buttons/default-orange.png'
                alt='Buy Me A Coffee'
                height='41'
                width='174'
              />
            </a>
          </div>
        </Details>
        <Thumbnail>
          <img src={heroImage} alt='Crio.Do' />
        </Thumbnail>
      </IntroWrapper>
    </div>
  );
};
